import { VolumePopoverPopup } from "../../../../../ui/volume-popover/popup.js";
import { VolumePopoverRoot } from "../../../../../ui/volume-popover/root.js";
import { VolumePopoverTrigger } from "../../../../../ui/volume-popover/trigger.js";
import { ButtonTooltip } from "../../../shared/components/buttons/button-tooltip.js";
import { VolumeSlider } from "../../../shared/components/sliders/volume-slider.js";
import { MuteButton } from "../buttons/mute-button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/minimal-audio/components/controls/volume-popover.tsx
function VolumePopover({ className, showTooltip = false, side = "top", orientation = "vertical", ...props } = {}) {
	return /* @__PURE__ */ jsxs(VolumePopoverRoot, {
		openOnHover: true,
		delay: 200,
		closeDelay: 100,
		side,
		...props,
		children: [/* @__PURE__ */ jsx(ButtonTooltip, {
			delay: 0,
			disabled: !showTooltip,
			sticky: true,
			side: "top",
			children: /* @__PURE__ */ jsx(VolumePopoverTrigger, { render: /* @__PURE__ */ jsx(MuteButton, { className: cn(className) }) })
		}), /* @__PURE__ */ jsx(VolumePopoverPopup, {
			className: cn("media-popup", "media-popup-safe-area", "media-popup-transition", "media-popup-surface", "media-volume-popover"),
			children: /* @__PURE__ */ jsx(VolumeSlider, { orientation })
		})]
	});
}
//#endregion
export { VolumePopover };

//# sourceMappingURL=volume-popover.js.map